import css from './CoreWeaveLogo.module.css';

export const CoreWeaveLogo = () => (
  <svg
    width="28"
    height="16"
    viewBox="0 0 28 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="CoreWeave Forge">
    <path
      aria-hidden="true"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0505 12.0731H7.01829C6.77318 12.0731 6.52586 11.9248 6.37791 11.6812L4.50975 8.34313C4.41038 8.09743 4.41038 7.85173 4.50975 7.65687L6.37791 4.31877C6.52586 4.07307 6.77097 3.92693 7.01829 3.92693H9.3303C9.57542 3.92693 9.82274 3.77866 9.97069 3.53508L11.6423 0.540111C11.7903 0.294414 11.5937 0 11.3464 0H5.15013C4.60912 0 4.16747 0.294414 3.87157 0.737093L0.183835 7.3095C-0.0612783 7.75218 -0.0612783 8.2923 0.183835 8.73286L3.87157 15.2629C4.11668 15.7056 4.60912 16 5.15013 16H13.0688C13.3647 16 13.5105 15.7056 13.3647 15.4599L11.6445 12.4162C11.5959 12.1705 11.3486 12.0731 11.0549 12.0731H11.0505Z"
      fill="#004AE1"
    />
    <path
      aria-hidden="true"
      d="M19.7581 0.239742C19.9038 -0.00595584 20.2478 -0.00595584 20.3958 0.239742L21.97 2.89111C22.2151 3.33167 22.2151 3.87226 21.97 4.31494L15.4778 15.8013C15.3298 16.0465 14.9861 16.0465 14.8381 15.8013L13.1174 12.7085C13.0181 12.5136 13.0181 12.2676 13.1174 12.022L19.7581 0.239742ZM25.5589 0.239742C25.7068 -0.00595584 26.0505 -0.00595584 26.1985 0.239742L27.7737 2.89111C28.0674 3.33166 28.0667 3.87227 27.8215 4.31494L21.3294 15.8013C21.1814 16.0465 20.8377 16.0465 20.6897 15.8013L18.9182 12.7085C18.8189 12.5137 18.8189 12.2676 18.9182 12.022L25.5589 0.239742ZM13.0178 0.19189C13.1658 -0.0535616 13.5105 -0.0535319 13.6585 0.19189L15.9192 4.06787C16.0186 4.31355 16.0186 4.60819 15.9192 4.80517L13.9524 8.2915V8.28955C13.853 8.53524 13.4597 8.53513 13.3118 8.24072L11.0989 4.26513C10.9996 4.07027 10.9996 3.77552 11.0989 3.57861L13.0178 0.19189Z"
      className={css.wordmark}
    />
  </svg>
);
